// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"91da9fe0","551":"18107338"}[chunkId] + ".chunk.js";
};